import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "../../../Icon";
import { Button } from "../../../uikit/Button";
import { Typography } from "../../../uikit/Typography";
import { useCancelConnectionConfirmModal } from "./CancelConnectionConfirmModal";

export const PendingButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  const cancelConnectionConfirmModal = useCancelConnectionConfirmModal();

  return (
    <Button
      variant="secondary"
      className="bg-secondary hover:!bg-v2-danger !h-8 w-full !border-none !px-1 !font-medium hover:!text-white"
      onClick={async () => {
        await cancelConnectionConfirmModal.show({
          onConfirm: async () => {
            void cancelConnectionConfirmModal.hide();
            // TODO: Call the API to cancel the connection here
            await Promise.resolve(() => {
              console.warn("Call cancel connection here");
            });
          },
          onCancel: () => {
            void cancelConnectionConfirmModal.hide();
          },
          // TODO: Add the connection target here
          recipient: "Melisa DonkeyKong",
        });
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Icon
        type={isHovered ? "16-cross" : "16-clock"}
        size={16}
        useWithFillCurrentColor
        className="mr-2 mt-[-3px]"
      />
      <Typography.LabelSm color="text-primary" weight="font-medium">
        {isHovered ? t("cancel") : t("pending")}
      </Typography.LabelSm>
    </Button>
  );
};
